export default __webpack_public_path__ + "2011 Tunable Holstein model with cold polar molecules.pdf";